import React from "react";
import { Box, Typography, Chip, Fade, Grow } from "@mui/material";
import { Code } from "@mui/icons-material";
import styled from "styled-components";

const SkillChip = styled(Chip)`
  margin: 0.5rem;
  transition: all 0.3s ease;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  }
`;

function SkillsSection() {
  const skills = [
    "React.js",
    "C#",
    ".NET",
    "Blazor",
    "Java",
    "JavaScript",
    "Python",
    "Full-Stack Development",
    "System Reliability",
    "API Development",
    "Mobile App Development",
    "Cross-functional Collaboration",
  ];

  return (
    <Box sx={{ mt: 6 }}>
      <Fade in timeout={1400}>
        <Typography
          variant="h4"
          component="h3"
          textAlign="center"
          gutterBottom
          sx={{
            fontWeight: 600,
            mb: 4,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: 1,
          }}
        >
          <Code sx={{ color: "#0066CC" }} />
          Skills
        </Typography>
      </Fade>

      <Box sx={{ textAlign: "center" }}>
        {skills.map((skill, index) => (
          <Grow in timeout={1500 + index * 100} key={skill}>
            <SkillChip
              label={skill}
              variant="outlined"
              color="primary"
              sx={{
                borderColor: "#0066CC",
                color: "#0066CC",
                fontWeight: 500,
              }}
            />
          </Grow>
        ))}
      </Box>
    </Box>
  );
}

export default SkillsSection;
